<template>
  <v-app :class="themeClass">
    <AppShell />
    <ErrorPopup />
    <DownloadLimitModal />
  </v-app>
</template>

<script setup>
import AppShell from "@app/components/layout/AppShell.vue";
import ErrorPopup from "@/components/layout/Popups/ErrorPopup.vue";
import DownloadLimitModal from "@/components/layout/Popups/DownloadLimitModal.vue";
import { useDarkMode } from "@app/composables/useDarkMode";

const { themeClass } = useDarkMode();
</script>
